import type { ReactNode } from 'react';
import { cx } from '../../lib/cx.ts';
import { InboxIcon } from '../icons.tsx';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  /**
   * What to do next, not what is missing. "Log a call or wait for the next
   * Fathom sync" beats "No calls found" every time, so this is required.
   */
  description: string;
  action?: ReactNode;
  /** Inside a card or table that already has its own padding. */
  compact?: boolean;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  compact = false,
}: EmptyStateProps) {
  return (
    <div
      className={cx(
        'flex flex-col items-center justify-center text-center',
        compact ? 'px-4 py-8' : 'px-6 py-14',
      )}
    >
      <div className="mb-3 flex size-9 items-center justify-center rounded-lg border border-border bg-surface-raised text-fg-subtle">
        {icon ?? <InboxIcon size={18} />}
      </div>
      <p className="text-sm font-medium text-fg">{title}</p>
      <p className="mt-1 max-w-xs text-xs leading-relaxed text-fg-subtle">{description}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
